export default __webpack_public_path__ + "static/media/cardpic.320b7d31.svg";